module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAGtJREFUKFOV0MkNgDAQQ9E/bYC4UgZSiqEyCkH0AScKMcohEdlY5vxk2WOSxMezX7gVKmkEVqALxmo4gycweFfgCnTAXuAaNLMj7IrJLegTE/wEE/wGc7wBE+BXO98x/1CsIakHFmCuwXvyBT+iUeC1k86zAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button-icon-01.png
// module id = Jn/Z
// module chunks = 1